/* Puptein quiz add-on: free-text matching, bundle suggestions and data capture.
   Works alongside the base quiz in puptein.js (which handles steps 1-3 for the tile answers). */
(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function reEsc(t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  // Whole-word match, allowing a plural "s"/"es" ("storm" matches "storms", "old" does not match "gold")
  function hasTerm(text, term) {
    term = (term || '').trim().toLowerCase();
    if (!term) return false;
    return new RegExp('(^|[^a-z])' + reEsc(term) + '(e?s)?($|[^a-z])').test(text);
  }

  function init(q) {
    if (q.dataset.quizPlus) return;
    q.dataset.quizPlus = '1';
    var data = {};
    try { data = JSON.parse($('[data-quiz-data]', q).textContent); } catch (e) { return; }
    var products = data.products || [], bundles = data.bundles || [], flags = data.redflags || [];
    var state = { age: null, path: null, text: '', need: '', match: [], bundle: null, vet: false, name: '' };

    // ---------- Pup name: personalizes questions + result ----------
    function cleanName(v) {
      v = (v || '').replace(/[<>{}\[\]]/g, '').replace(/\s+/g, ' ').trim().slice(0, 40);
      return v ? v.charAt(0).toUpperCase() + v.slice(1) : '';
    }
    function possessive() {
      if (!state.name) return 'Their';
      return state.name + "'s";
    }
    function personalize() {
      $$('[data-pup-q]', q).forEach(function (el) {
        if (!el.dataset.orig) el.dataset.orig = el.textContent;
        var t = el.dataset.orig;
        if (state.name) t = t.replace(/your (dog|pup)/i, state.name);
        el.textContent = t;
      });
      $$('[data-pup-poss]', q).forEach(function (el) { el.textContent = possessive(); });
    }
    var nameInput = $('[data-quiz-name]', q);
    if (nameInput) {
      nameInput.addEventListener('input', function () { state.name = cleanName(nameInput.value); personalize(); if (typeof renderDogs === 'function' && dogsOn) renderDogs(); });
      nameInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); nameInput.blur(); } });
    }

    var hasDogs = !!$('[data-quiz-step="dogs"]', q);
    function steps(n) {
      $$('[data-quiz-step]', q).forEach(function (s) { var on = s.dataset.quizStep === String(n); s.hidden = !on; s.classList.toggle('is-active', on); });
      var num = ({ '1': 1, 'dogs': 2, '2': hasDogs ? 3 : 2, 'other': hasDogs ? 3 : 2, '3': hasDogs ? 4 : 3 })[String(n)] || 1;
      $$('[data-quiz-dot]', q).forEach(function (d) { d.classList.toggle('is-active', parseInt(d.dataset.quizDot, 10) <= num); });
    }

    // ---------- Dogs and weights: how many pouches to send ----------
    var D = data.dogs || {}, dogsOn = !!(D.on && hasDogs);
    var dogs = [25];
    function parseGuide(txt) {
      return (txt || '').split(/\n/).map(function (l) {
        var parts = l.split('|'); if (parts.length < 2) return null;
        var nums = (parts[0].match(/\d+(\.\d+)?/g) || []).map(Number), open = /above|over|\+|more/i.test(parts[0]);
        return { max: open || !nums.length ? Infinity : nums[nums.length - 1], scoops: parseFloat(parts[1]) };
      }).filter(function (r) { return r && r.scoops > 0; }).sort(function (a, b) { return a.max - b.max; });
    }
    var guide = parseGuide(D.guide);
    function scoopsFor(w) { for (var i = 0; i < guide.length; i++) if (w <= guide[i].max) return guide[i].scoops; return guide.length ? guide[guide.length - 1].scoops : 1; }
    function daysOf(name) { var m = /(\d+)\s*(day|week|month)/i.exec(name || ''); if (!m) return 0; var n = +m[1], u = m[2].toLowerCase(); return u === 'day' ? n : u === 'week' ? n * 7 : n * 30; }
    var dogsBox = $('[data-quiz-dogs]', q), dogAdd = $('[data-quiz-dog-add]', q);
    function dogLabel(i) { return i === 0 && state.name ? state.name : 'Dog ' + (i + 1); }
    function renderDogs() {
      if (!dogsBox) return;
      var min = +dogsBox.dataset.min || 5, max = +dogsBox.dataset.max || 150, maxDogs = +dogsBox.dataset.maxDogs || 5;
      dogsBox.innerHTML = '';
      dogs.forEach(function (w, i) {
        var row = document.createElement('div');
        row.className = 'qd__dog';
        row.innerHTML = '<div class="qd__head"><span class="qd__name"><i>' + pawSvg + '</i>' + esc(dogLabel(i)) + '</span><span class="qd__wt"><span data-w>' + w + '</span> <small>lb</small></span>' +
          (dogs.length > 1 ? '<button type="button" class="qd__rm" aria-label="Remove ' + esc(dogLabel(i)) + '">&times;</button>' : '') + '</div>' +
          '<input class="qd__range" type="range" min="' + min + '" max="' + max + '" step="1" value="' + w + '" aria-label="' + esc(dogLabel(i)) + ' weight in pounds">' +
          '<div class="qd__sc" data-sc></div>';
        var r = $('input', row);
        function sync() {
          var v = +r.value; dogs[i] = v;
          $('[data-w]', row).textContent = v;
          r.style.setProperty('--fill', ((v - min) / (max - min) * 100) + '%');
          var sc = scoopsFor(v); $('[data-sc]', row).textContent = sc + (sc === 1 ? ' scoop' : ' scoops') + ' a day';
        }
        r.addEventListener('input', sync);
        var rm = $('.qd__rm', row); if (rm) rm.addEventListener('click', function () { dogs.splice(i, 1); renderDogs(); });
        sync();
        dogsBox.appendChild(row);
      });
      if (dogAdd) dogAdd.hidden = dogs.length >= maxDogs;
    }
    var pawSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="5.5" cy="10" r="2.2"/><circle cx="9.5" cy="5.5" r="2.2"/><circle cx="14.5" cy="5.5" r="2.2"/><circle cx="18.5" cy="10" r="2.2"/><path d="M12 11c-3 0-5.8 3.7-5.8 6.2 0 1.9 1.5 2.8 3.2 2.8 1 0 1.7-.5 2.6-.5s1.6.5 2.6.5c1.7 0 3.2-.9 3.2-2.8 0-2.5-2.8-6.2-5.8-6.2Z"/></svg>';
    if (dogsOn) {
      renderDogs();
      if (dogAdd) dogAdd.addEventListener('click', function () { dogs.push(25); renderDogs(); });
      var dgo = $('[data-quiz-dogs-go]', q);
      if (dgo) dgo.addEventListener('click', function () {
        track('Quiz Dogs', { dogs: dogs.length, weights: dogs.join(', '), page: location.pathname });
        steps(2);
        q.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // The order box under a match: pouches for these dogs, Subscribe or One-time, one tap to cart
    function planHTML(list) {
      var scoops = dogs.reduce(function (a, w) { return a + scoopsFor(w); }, 0) || 1;
      var per = +D.per || 90, subDays = daysOf(D.subName) || 42, oneDays = +D.onetimeDays || 42;
      var canSub = list.every(function (p) { return p.plan && p.subCents; });
      var qSub = Math.max(1, Math.min(9, Math.ceil(scoops * subDays / per - 0.05)));
      var qOne = Math.max(1, Math.min(9, Math.ceil(scoops * oneDays / per - 0.05)));
      var box = document.createElement('div');
      box.className = 'qp';
      box.dataset.sub = canSub ? '1' : '';
      box.innerHTML = '<p class="qp__k">' + esc(state.name ? 'What ' + state.name + ' needs' : 'What to order') + '</p>' +
        '<div class="qp__big"><strong data-qp-n></strong><span data-qp-unit></span></div>' +
        '<div class="qp__mix" data-qp-mix></div><p class="qp__why" data-qp-why></p>' +
        (canSub ? '<div class="qp__opts"><button type="button" class="qp__opt" data-qp-mode="sub" aria-pressed="false"><strong>Subscribe &amp; save</strong>Every ' + Math.round(subDays / 7) + ' weeks, skip anytime</button>' +
          '<button type="button" class="qp__opt" data-qp-mode="one" aria-pressed="true"><strong>One-time</strong>No commitment</button></div>' : '') +
        '<p class="qp__total"><strong data-qp-total></strong><s data-qp-full></s><span data-qp-day></span></p><p class="qp__save" data-qp-save></p>' +
        '<form data-ajax-cart class="qp__form" data-qp-form></form>';
      var mode = 'one'; // One-time is preselected; Subscribe & save sits first, one tap away
      function draw() {
        var q1 = mode === 'sub' ? qSub : qOne, n = q1 * list.length, days = mode === 'sub' ? subDays : oneDays;
        var s2 = +D.save2 || 0, s3 = +D.save3 || 0, pct = n >= 3 ? s3 : n === 2 ? s2 : 0;
        var full = 0, gross = 0;
        list.forEach(function (p) { full += (p.cents || 0) * q1; gross += (mode === 'sub' ? p.subCents : p.cents) * q1; });
        var total = Math.round(gross * (1 - pct / 100)), lasts = Math.floor(q1 * per / scoops);
        $('[data-qp-n]', box).textContent = n;
        $('[data-qp-unit]', box).textContent = (n === 1 ? 'pouch' : 'pouches') + (mode === 'sub' ? ' every ' + Math.round(subDays / 7) + ' weeks' : '');
        $('[data-qp-mix]', box).innerHTML = list.length > 1 ? list.map(function (p) { return '<span>' + q1 + ' ' + esc(p.title) + '</span>'; }).join('') : '';
        var who = dogs.length > 1 ? 'Your ' + dogs.length + ' dogs eat' : (state.name ? state.name + ' eats' : 'Your dog eats');
        $('[data-qp-why]', box).textContent = who + ' about ' + scoops + (scoops === 1 ? ' scoop' : ' scoops') + ' a day' + (list.length > 1 ? ' of each formula' : '') + ', so ' +
          (q1 === 1 ? 'one pouch' : q1 + ' pouches') + (list.length > 1 ? ' of each' : '') + ' ' + (q1 === 1 ? 'lasts' : 'last') + ' about ' + lasts + ' days.';
        $('[data-qp-total]', box).textContent = money(total);
        $('[data-qp-full]', box).textContent = full > total ? money(full) : '';
        $('[data-qp-day]', box).textContent = (mode === 'sub' ? 'per delivery, ' : '') + money(Math.round(total / Math.max(1, lasts))) + ' a day';
        $('[data-qp-save]', box).textContent = pct ? pct + '% multi-pouch savings included, applied at checkout' : '';
        $$('[data-qp-mode]', box).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.qpMode === mode ? 'true' : 'false'); });
        var f = $('[data-qp-form]', box), h = '';
        list.forEach(function (p, i) {
          h += '<input type="hidden" name="items[' + i + '][id]" value="' + p.variant + '"><input type="hidden" name="items[' + i + '][quantity]" value="' + q1 + '">';
          if (mode === 'sub') h += '<input type="hidden" name="items[' + i + '][selling_plan]" value="' + p.plan + '">';
          if (dogs.length > 1) h += '<input type="hidden" name="items[' + i + '][properties][For]" value="' + dogs.length + ' dogs">';
        });
        f.innerHTML = h + '<button type="submit" class="btn btn--lg" data-add-btn>Add ' + n + ' ' + (n === 1 ? 'pouch' : 'pouches') + ' to cart</button>';
      }
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-qp-mode]'); if (b) { mode = b.dataset.qpMode; draw(); } });
      draw();
      return box;
    }
    // Single match: swap the plain Add to cart for the order box
    function attachSingle(key) {
      $$('.qp', q).forEach(function (el) { if (!el.closest('[data-quiz-result="combo"]')) el.remove(); });
      if (!dogsOn) return;
      var p = products.filter(function (x) { return String(x.id) === String(key); })[0];
      var panel = $('[data-quiz-result="' + key + '"]', q);
      if (!p || !panel || !p.available) return;
      var form = $('.quiz__match form', panel); if (form) form.classList.add('is-planned');
      var match = $('.quiz__match', panel);
      if (match) match.insertAdjacentElement('afterend', planHTML([p]));
    }
    function showResult(key) {
      $$('[data-quiz-result]', q).forEach(function (r) { r.hidden = r.dataset.quizResult !== String(key); });
      if (key !== 'combo' && key !== 'vet' && key !== 'none') attachSingle(key);
      $$('[data-quiz-senior-only]', q).forEach(function (el) { el.hidden = state.age !== 'senior'; });
      var ctx = $('[data-quiz-context]', q);
      if (ctx) {
        if (state.path === 'text' && state.text) { ctx.innerHTML = 'Based on: <strong>"' + esc(state.text) + '"</strong>'; ctx.hidden = false; }
        else ctx.hidden = true;
      }
      steps(3);
      var email = $('[data-quiz-email]', q);
      if (email) email.hidden = key === 'vet' || key === 'none';
      q.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // ---------- Data capture ----------
    function payload() {
      return {
        pup_name: state.name || '',
        dog_age: state.age || '',
        path: state.path || '',
        need: state.need || '',
        typed_answer: state.text || '',
        matched_products: state.match.map(function (p) { return p.title; }),
        suggested_bundle: state.bundle ? state.bundle.title : '',
        vet_referral: state.vet,
        dogs: dogsOn ? dogs.length : '',
        dog_weights: dogsOn ? dogs.join(', ') : '',
        page: location.pathname
      };
    }
    function track(name, props) {
      try {
        if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track(name, props);
        else (window._learnq = window._learnq || []).push(['track', name, props]);
      } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name.toLowerCase().replace(/\s+/g, '_'), props); } catch (e) {}
    }
    function complete() {
      var p = payload();
      track('Completed Quiz', p);
      // Saved on the cart, so it lands on the order (hidden from the shopper at checkout)
      var attrs = {
        _quiz_dog_age: p.dog_age, _quiz_path: p.path, _quiz_need: p.need,
        _quiz_typed: p.typed_answer.slice(0, 300), _quiz_match: p.matched_products.join(' + '),
        _quiz_bundle: p.suggested_bundle, _quiz_vet: p.vet_referral ? 'yes' : '', _quiz_dogs: p.dog_weights ? p.dogs + ' (' + p.dog_weights + ' lb)' : ''
      };
      if (p.pup_name) attrs['Pup name'] = p.pup_name;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
    }

    // Tile path (base quiz handles the UI; we just record it)
    $$('[data-quiz-age]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        state.age = b.dataset.quizAge;
        track('Started Quiz', { dog_age: state.age, pup_name: state.name, page: location.pathname });
      });
    });
    $$('[data-quiz-need]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var id = parseInt(b.dataset.quizNeed, 10);
        var p = products.filter(function (x) { return x.id === id; })[0];
        state.path = 'tile'; state.text = ''; state.vet = false; state.bundle = null;
        state.need = (b.textContent || '').trim();
        state.match = p ? [p] : [];
        var ctx = $('[data-quiz-context]', q); if (ctx) ctx.hidden = true;
        var email = $('[data-quiz-email]', q); if (email) email.hidden = false;
        attachSingle(b.dataset.quizNeed);
        complete();
      });
    });
    $$('[data-quiz-restart]', q).forEach(function (b) {
      b.addEventListener('click', function () { state = { age: null, path: null, text: '', need: '', match: [], bundle: null, vet: false, name: state.name }; if (typeof picks !== 'undefined') { picks.length = 0; syncPicks(); } personalize(); });
    });

    // ---------- Multiple needs (tiles) ----------
    var picks = [], goBtn = $('[data-quiz-pick-go]', q), pickHint = $('[data-quiz-pick-hint]', q);
    var maxPicks = goBtn ? parseInt(goBtn.dataset.max, 10) || 3 : 3, hintText = pickHint ? pickHint.textContent : '';
    function syncPicks() {
      $$('[data-quiz-pick]', q).forEach(function (b) { b.setAttribute('aria-pressed', picks.indexOf(b.dataset.quizPick) > -1 ? 'true' : 'false'); });
      if (goBtn) {
        goBtn.disabled = !picks.length;
        var cnt = $('[data-quiz-pick-count]', goBtn); if (cnt) cnt.textContent = picks.length > 1 ? '(' + picks.length + ')' : '';
      }
    }
    $$('[data-quiz-pick]', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.quizPick, i = picks.indexOf(k);
        if (pickHint) { pickHint.textContent = hintText; pickHint.classList.remove('is-warn'); }
        if (i > -1) picks.splice(i, 1);
        else if (picks.length >= maxPicks) {
          if (pickHint) { pickHint.textContent = pickHint.dataset.maxMsg || hintText; pickHint.classList.add('is-warn'); }
          return;
        } else picks.push(k);
        syncPicks();
      });
    });
    if (goBtn) goBtn.addEventListener('click', function () {
      if (!picks.length) return;
      var chosen = picks.map(function (k) { return products.filter(function (x) { return String(x.id) === k; })[0]; }).filter(Boolean);
      state.path = 'tile'; state.text = ''; state.vet = false; state.bundle = null;
      state.need = picks.map(function (k) { var t = $('[data-quiz-pick="' + k + '"]', q); return t ? t.dataset.label : k; }).join(' + ');
      state.match = chosen;
      if (chosen.length >= 2) { renderCombo(chosen); complete(); showResult('combo'); }
      else { complete(); showResult(picks[0]); }
    });

    // ---------- Free-text path ----------
    var otherBtn = $('[data-quiz-other]', q), form = $('[data-quiz-other-form]', q);
    if (otherBtn && form) {
      otherBtn.addEventListener('click', function () {
        steps('other');
        setTimeout(function () { var t = $('textarea', form); if (t) t.focus(); }, 50);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var ta = $('textarea', form), raw = (ta.value || '').trim();
        if (raw.length < 3) { ta.focus(); return; }
        var text = ' ' + raw.toLowerCase().replace(/[’']/g, "'") + ' ';
        state.path = 'text'; state.text = raw; state.need = 'Something else'; state.bundle = null; state.match = []; state.vet = false;

        if (flags.some(function (f) { return hasTerm(text, f); })) {
          state.vet = true; complete(); showResult('vet'); return;
        }
        var scored = products.map(function (p) {
          var n = 0;
          (p.kw || []).forEach(function (k) { if (hasTerm(text, k)) n++; });
          return { p: p, n: n };
        }).filter(function (x) { return x.n > 0; }).sort(function (a, b) { return b.n - a.n; });
        state.match = scored.slice(0, 2).map(function (x) { return x.p; });

        if (!state.match.length) { complete(); showResult('none'); return; }
        if (state.match.length === 1) { complete(); showResult(state.match[0].id); return; }
        renderCombo(state.match);
        complete();
        showResult('combo');
      });
    }

    // Smallest available bundle that contains every picked formula
    function findBundle(list) {
      var ids = list.map(function (p) { return p.id; });
      var hits = bundles.filter(function (x) {
        return x.inc && ids.every(function (id) { return x.inc.indexOf(id) > -1; });
      });
      hits.sort(function (x, y) { return (x.available === y.available ? 0 : x.available ? -1 : 1) || x.inc.length - y.inc.length; });
      return hits[0] || null;
    }
    function money(c) {
      var f = (data.copy && data.copy.money) || '${{amount}}';
      var amt = (Math.round(c) / 100).toFixed(2);
      return f.replace(/\{\{\s*amount[^}]*\}\}/, amt.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    }

    // Two or more formulas: Subscribe & save on all of them is the main offer (best value and keeps them on a routine).
    // A bundle that covers every pick shows underneath as the one-time option.
    function renderCombo(list) {
      var box = $('[data-quiz-result="combo"]', q);
      var copy = data.copy || {};
      var bundle = findBundle(list);
      state.bundle = bundle && bundle.available ? bundle : null;
      var avail = list.filter(function (p) { return p.available; });
      var row = function (p) {
        return '<div class="qc__item">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="56" height="56">' : '<span></span>') +
          '<div><strong>' + esc(p.title) + (p.available ? '' : '<span class="qc__soon">Coming soon</span>') + '</strong><span>' + esc(p.desc || '') + '</span></div>' +
          '<a href="' + esc(p.url) + '">Details</a></div>';
      };
      var title = (copy.comboOne || 'A [count]-formula routine').replace('[count]', list.length);
      var html = '<p class="eyebrow"><span data-pup-poss>' + esc(possessive()) + '</span> match</p><p class="h3" style="color:var(--c-primary)">' + esc(title) + '</p>' +
        '<div class="qc">' + list.map(row).join('') + '</div>';
      if (avail.length && dogsOn) {
        html += '<div data-qp-slot></div>';
      } else if (avail.length) {
        var canSub = avail.every(function (p) { return p.plan && p.subCents; });
        var full = avail.reduce(function (t, p) { return t + (p.cents || 0); }, 0);
        var sub = canSub ? avail.reduce(function (t, p) { return t + p.subCents; }, 0) : full;
        html += '<form data-ajax-cart class="qc__form" data-qc-both>';
        avail.forEach(function (p, i) {
          html += '<input type="hidden" name="items[' + i + '][id]" value="' + p.variant + '"><input type="hidden" name="items[' + i + '][quantity]" value="1">';
          if (canSub) html += '<input type="hidden" name="items[' + i + '][selling_plan]" value="' + p.plan + '" data-qc-plan>';
        });
        if (canSub) {
          html += '<label class="qc__sub"><input type="checkbox" data-qc-subtoggle> <span><strong>Subscribe &amp; save' + (avail.length === 1 ? '' : avail.length === 2 ? ' on both' : ' on all ' + avail.length) + '.</strong> ' + esc(copy.subLine || '') + '</span></label>';
        }
        html += '<p class="qc__total" data-qc-total data-full="' + full + '" data-sub="' + sub + '"><span>' + (avail.length === list.length ? 'Total' : 'Available now') + '</span><span>' +
          (canSub && sub < full ? '<s>' + money(full) + '</s>' : '') + '<strong>' + money(canSub ? sub : full) + '</strong></span></p>';
        var label = avail.length === 1 ? 'Add ' + avail[0].title + ' to cart' : (avail.length === list.length ? (avail.length === 2 ? 'Add both to cart' : 'Add all ' + avail.length + ' to cart') : 'Add the ' + avail.length + ' available');
        html += '<button type="submit" class="btn btn--primary qc__cta" data-add-btn>' + esc(label) + '</button></form>';
      } else {
        html += '<p class="qc__fine">These are coming soon. Tap Details to get notified, or leave your email below and we\'ll send your match.</p>';
      }
      if (state.bundle) {
        var b = state.bundle;
        html += '<div class="qc__alt"><p>' + esc(copy.bundleAlt || 'Rather buy once?') + '</p><button type="button" class="btn btn--outline btn--sm" data-qc-bundle>Add pack</button>' +
          '<p><strong>' + esc(b.title) + '</strong>' + esc(b.price) + (b.compareCents > b.cents ? ' <s>' + money(b.compareCents) + '</s>' : '') + ', one-time</p></div>' +
          '<form data-ajax-cart class="qc__form" data-qc-bundle-form hidden><input type="hidden" name="id" value="' + b.variant + '"><input type="hidden" name="quantity" value="1"><button type="submit" data-add-btn hidden></button></form>';
      }
      html += '<p class="qc__fine">A suggestion based on what you told us, not a diagnosis.</p>';
      box.innerHTML = html;
      var slot = $('[data-qp-slot]', box);
      if (slot) slot.replaceWith(planHTML(avail));
      var tog = $('[data-qc-subtoggle]', box), tot = $('[data-qc-total]', box);
      if (tog) tog.addEventListener('change', function () {
        $$('[data-qc-plan]', box).forEach(function (i) { i.disabled = !tog.checked; });
        if (tot) {
          var f = +tot.dataset.full, sb = +tot.dataset.sub;
          tot.lastElementChild.innerHTML = tog.checked && sb < f ? '<s>' + money(f) + '</s><strong>' + money(sb) + '</strong>' : '<strong>' + money(f) + '</strong>';
        }
      });
      if (tog) tog.dispatchEvent(new Event('change')); // start as one-time: plans off, full price shown
      var bb = $('[data-qc-bundle]', box);
      if (bb) bb.addEventListener('click', function () {
        var f = $('[data-qc-bundle-form]', box), btn = f && $('button', f);
        if (btn) btn.click();
      });
    }

    // ---------- Email capture ----------
    var ef = $('[data-quiz-email]', q);
    if (ef) {
      ef.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = $('input[type="email"]', ef), email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { input.focus(); return; }
        var p = payload(), cfg = data.klaviyo || {};
        var btn = $('button', ef); if (btn) btn.disabled = true;
        var props = { quiz_dog_age: p.dog_age, quiz_pup_name: p.pup_name, quiz_need: p.need, quiz_typed_answer: p.typed_answer, quiz_match: p.matched_products.join(' + '), quiz_bundle: p.suggested_bundle };
        // Identify saves the quiz answers as profile properties and ties earlier quiz events to this email
        if (p.pup_name) props.pup_name = p.pup_name;
        try {
          if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify(Object.assign({ email: email }, props));
          else (window._learnq = window._learnq || []).push(['identify', Object.assign({ $email: email }, props)]);
        } catch (err) {}
        // Everything goes straight to Klaviyo's client API, so it works even if the Klaviyo app embed isn't on the page.
        var kUrl = function (path) { return 'https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(cfg.key); };
        var kPost = function (path, body) {
          return fetch(kUrl(path), { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
            .then(function (r) { if (!r.ok && r.status !== 202) throw new Error('klaviyo ' + r.status); return r; });
        };
        var abs = function (u) { if (!u) return ''; if (u.indexOf('//') === 0) return 'https:' + u; if (u.charAt(0) === '/') return location.origin + u; return u; };
        // Event data the "Quiz match email" flow uses to build the email
        var ev = { pup_name: p.pup_name, dog_age: p.dog_age, need: p.need, typed_answer: p.typed_answer, match_count: state.match.length, vet_referral: !!p.vet_referral, page: location.href };
        state.match.slice(0, 3).forEach(function (m, i) {
          var k = 'match_' + (i + 1) + '_';
          ev[k + 'title'] = m.title; ev[k + 'url'] = abs(m.url); ev[k + 'desc'] = m.desc || '';
          ev[k + 'image'] = abs(m.img); ev[k + 'price'] = m.price || ''; ev[k + 'sub_price'] = m.subPrice || '';
        });
        if (state.bundle) {
          ev.bundle_title = state.bundle.title; ev.bundle_url = abs(state.bundle.url);
          ev.bundle_price = state.bundle.price || ''; ev.bundle_image = abs(state.bundle.img);
        }
        var profileProps = {};
        Object.keys(props).forEach(function (k) { if (props[k] !== '' && props[k] != null) profileProps[k] = props[k]; });
        // 1) Subscribe to the email list (consent line sits under the button)
        var sub = { data: { type: 'subscription', attributes: { custom_source: 'Puptein quiz', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: cfg.list } } } } };
        // 2) Event that triggers the match email, and saves the answers (pup_name etc.) on the profile
        var evt = { data: { type: 'event', attributes: { properties: ev, metric: { data: { type: 'metric', attributes: { name: 'Requested Quiz Match Email' } } }, profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } } } } };
        kPost('subscriptions', sub)
          .catch(function () {})
          .then(function () { return kPost('events', evt); })
          .then(function () {
            // Different name on purpose: "Requested Quiz Match Email" is sent once above and triggers the flow
            track('Submitted Quiz Email', p);
            ef.classList.add('is-done');
            var done = $('[data-quiz-email-done]', ef); if (done) done.hidden = false;
          })
          .catch(function () {
            if (btn) btn.disabled = false;
            var t = $('.qe__fine', ef); if (t) t.textContent = 'Something went wrong. Please try again.';
          });
      });
    }
  }

  function boot() { $$('[data-quiz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
